/* eslint-disable @typescript-eslint/no-unused-vars */
import authSvc from '@efex-services/auth/authSvc';
import { FormControl, Grid, InputLabel, MenuItem, Select } from '@mui/material';
import CompanyOperation from '@pages/onboarding/components/CompanyOperation/CompanyOperation';
import { t } from 'i18next';
import { useEffect, useState } from 'react';
import {
  Control,
  Controller,
  FieldErrors,
  UseFormRegister,
  UseFormSetValue,
} from 'react-hook-form';
import { UseFileServiceReturn } from '@efex-components/EfexDS/FileInput/types/useFileService.type';
import type { FormularyDataUSA } from '../../steps/CompanyDocumentation';

interface NewCompanyDocumentsProps {
  register: UseFormRegister<FormularyDataUSA>;
  setValue: UseFormSetValue<FormularyDataUSA>;
  errors: FieldErrors<FormularyDataUSA>;
  control: Control<FormularyDataUSA, any>;
  useFileService: UseFileServiceReturn;
}

const NewCompanyDocuments = ({
  register,
  errors,
  control,
  useFileService,
}: NewCompanyDocumentsProps) => {
  const [search] = useState('');
  const [industryCodes, setIndustryCodes] = useState<Record<string, string>[]>(
    []
  );

  const requestIndsutryCodes = async () => {
    try {
      const result = await authSvc.getIndsutryCodes({ search });
      setIndustryCodes(result);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    requestIndsutryCodes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  return (
    <Grid container xs={12} className="!my-[15px]" rowGap={2}>
      {industryCodes.length ? (
        <Grid item xs={12}>
          <FormControl fullWidth>
            <InputLabel id="industryCode">
              {t('onbRegistryindustryCode')}
            </InputLabel>
            <Controller
              name="industryCode"
              control={control}
              render={({ field: { value } }) => (
                <Select
                  labelId="industryCode"
                  id="industryCode"
                  className="w-[90%]"
                  label={t('onbRegistryindustryCode')}
                  value={
                    value
                      ? industryCodes.find((code) => code.code === value)?.code
                      : ''
                  }
                  error={!!errors.industryCode}
                  {...register('industryCode', { required: true })}
                >
                  {industryCodes.map((code) => (
                    <MenuItem key={code.code} value={code.code}>
                      {industryCodes?.find((val) => val.code === value)?.value}
                      {t(code.name)}
                    </MenuItem>
                  ))}
                </Select>
              )}
            />
          </FormControl>
          {errors &&
            errors.industryCode &&
            errors.industryCode.type === 'required' && (
              <p className="text-orange-600 text-xs mt-1">
                {t('defaultError')}
              </p>
            )}
        </Grid>
      ) : null}
      <Grid item xs={12}>
        <CompanyOperation useExistingFileService={useFileService} />
      </Grid>
    </Grid>
  );
};

export default NewCompanyDocuments;
